import React from 'react';
import { Upload, ClipboardCheck, CreditCard, UserCheck, Mail, FileCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

  // Icon size and color to match ISM theme
  const ICON_SIZE = 48;
  const ICON_COLOR = '#007bff'; // ISM primary blue color

  // Map step numbers to Lucide components
  const stepIcons = {
    1: <Upload size={ICON_SIZE} color={ICON_COLOR} />,
    2: <ClipboardCheck size={ICON_SIZE} color={ICON_COLOR} />,
    3: <CreditCard size={ICON_SIZE} color={ICON_COLOR} />,
    4: <UserCheck size={ICON_SIZE} color={ICON_COLOR} />,
    5: <Mail size={ICON_SIZE} color={ICON_COLOR} />,
    6: <FileCheck size={ICON_SIZE} color={ICON_COLOR} />
  };

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('How It Works')}</h2>
          <div className="bottom-line"></div>
          <p className="center mb-4">{t('Steps to get your medical forms completed at Richmond In-Store Medical Clinic')}</p>

          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="row">
                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[1]}</div>
                    <h4>{t('Upload Your Form')}</h4>
                    <p>{t('Securely upload your form using our online request system.')}</p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[2]}</div>
                    <h4>{t('Complete Questionnaire')}</h4>
                    <p>{t('Fill out a short questionnaire about your request.')}</p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[3]}</div>
                    <h4>{t('Payment')}</h4>
                    <p>{t('Pay the form completion fee.')}</p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[4]}</div>
                    <h4>{t('Provider Review')}</h4>
                    <p>{t('A healthcare provider will review your chart and complete the form.')}</p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[5]}</div>
                    <h4>{t('Form Delivered')}</h4>
                    <p>{t("We'll email you the completed form.")}</p>
                  </div>
                </div>

                <div className="col-md-4 mb-4">
                  <div className="text-center">
                    <div className="step-icon mb-3">{stepIcons[6]}</div>
                    <h4>{t('Use Your Form')}</h4>
                    <p>{t('Submit your completed form to the requesting organization.')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HowItWorks;
